import { useEffect, useRef, useState } from 'react';

export const useFrozenValueUntil = (value, deps, shouldUpdate) => {
  const valueRef = useRef(value);
  valueRef.current = value;

  const [frozenValue, setFrozenValue] = useState(value);

  useEffect(() => {
    if (shouldUpdate) {
      setFrozenValue(valueRef.current);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldUpdate, ...deps]);

  return frozenValue;
};
